import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M8.537 14.795a6.75 6.75 0 1 1 6.926 0 11.25 11.25 0 0 1 6.28 5.08.75.75 0 0 1-1.299.75 9.75 9.75 0 0 0-16.888 0 .75.75 0 0 1-1.3-.75 11.25 11.25 0 0 1 6.281-5.08M6.75 9a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0"
      clipRule="evenodd"
    />
  </>
);

const Profile = Icon('profile', svgContents);

export default Profile;
